import Overview from './Overview';
import Trip from './Trip';
import Route from './Route';
import Charge from './Charge';
import VoiceAssistant from './VoiceAssistant';
import Defrost from './Defrost';
import Inside from './Inside';

const Scenes = {
    Overview,
    Trip,
    Route,
    Charge,
    VoiceAssistant,
    Defrost,
    Inside,
};

export default Scenes;
